/**
 * review-status-icon-exercise-handler.js
 */

import React from 'react';
import { ReviewResult, ReviewStatusIcon } from './review-status-icon';


export default function ReviewStatusIconExerciseHandler(props) {
  const {
    reviewStats,
    isAvailable,
    to,
    showTooltip
  } = props;

  if (!isAvailable) return null;

  let resultId = null;
  let count = 0;

  if (reviewStats.rejected > 0) {
    resultId = ReviewResult.REJECTED;
    count = reviewStats.rejected;
  } else if (reviewStats.notReviewed > 0) {
    resultId = ReviewResult.NOT_REVIEWED;
    count = reviewStats.notReviewed;
  } else {
    resultId = ReviewResult.REVIEWED;
  }

  return (
    <ReviewStatusIcon
      resultId={resultId}
      count={count}
      to={to}
      showTooltip={showTooltip}
    />
  )
}